import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    items: [],
    heading: {},
    suggestions: [],
    welcomeMessage: '',
    welcomeEnabled: false,
    // Template content that item rows cannot express (the persona card, the launcher button,
    // the welcome toggle). One JSON blob, ChatAiBlock.Data.
    data: {},
  },

  blockDesign: {},

  containerDesign: {},
  itemDesign: {},
  embedKey: '',
};

export const chatAiSlice = createSlice({
  name: 'chatAi',
  initialState,
  reducers: {
    chatStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.blockContent = {
        items: blockContent.items ?? [],
        heading: blockContent.heading ?? {},
        suggestions: blockContent.suggestions ?? [],
        welcomeMessage: blockContent.welcomeMessage ?? '',
        welcomeEnabled: blockContent.welcomeEnabled ?? false,
        data: blockContent.data ?? {},
      };

      state.containerDesign = containerDesign ?? {};
      state.itemDesign = itemDesign ?? {};

      state.blockDesign = blockDesign ?? {};
      state.embedKey = block.embedKey ?? '';
    },

    chatClear: () => initialState,

    removeItem: (state, action) => {
      const id = action.payload;
      state.blockContent.items = state.blockContent.items.filter((item) => item.id !== id);
    },

    chatUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },

    chatUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },

    chatUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },

    chatUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },

    chatUpdateEmbedKey: (state, action) => {
      state.embedKey = action.payload;
    },
  },
});

// Selectors
export const selectChatId = (state) => state.chatAi.id;
export const selectChatUID = (state) => state.chatAi.uid;
export const selectChatSID = (state) => state.chatAi.sid;

export const selectChatIsLoading = (state) => state.chatAi.isLoading;

export const selectChatBlockContent = (state) => state.chatAi.blockContent;
export const selectChatBlockDesign = (state) => state.chatAi.blockDesign;

export const selectChatContainerDesign = (state) => state.chatAi.containerDesign;
export const selectChatItemDesign = (state) => state.chatAi.itemDesign;
export const selectChatEmbedKey = (state) => state.chatAi.embedKey;
/** Template content blob — written through BlockContentContext so the preview follows along. */
export const selectChatData = (state) => state.chatAi.blockContent.data;

// Actions
export const { chatStore, removeItem, chatClear, chatUpdateBlockContent, chatUpdateBlockDesign, chatUpdateIsActive, chatUpdateIsLoading, chatUpdateEmbedKey } = chatAiSlice.actions;

// Reducer
export default chatAiSlice.reducer;
